module.exports = __webpack_public_path__ + "static/media/reward.252ff0a3.png";